import classNames from "classnames";
import { isNotPresent } from "neetocist";
import { withT } from "neetocommons/react-utils";
import { Edit } from "neetoicons";
import { Button, Typography } from "neetoui";

import Checkbox from "./Checkbox";
import DragHandle from "./DragHandle";
import OptionActions from "./OptionActions";

const BlockOption = withT(
  ({
    t,
    innerRef,
    hideDeleteOption = false,
    hideCloneOption = false,
    draggableProps,
    dragHandleProps,
    label,
    onEdit,
    onClone,
    handleDeleteClick,
    id,
    isDraggable,
    optionIndex,
    arrayHelpers,
    isCheckboxEnabled,
    name,
    placeholder,
  }) => (
    <div ref={innerRef} {...draggableProps} {...dragHandleProps}>
      <div
        className="neeto-ui-border-gray-400 hover:neeto-ui-bg-gray-200 neeto-ui-rounded group relative mb-2 ml-3 flex h-10 cursor-pointer items-center gap-2 border p-3 shadow-xs transition-colors duration-300 ease-in-out"
        data-testid="address-field-block"
      >
        {isDraggable && (
          <DragHandle
            {...dragHandleProps}
            className="absolute top-1/2 -left-0.5 -translate-x-full -translate-y-1/2"
            data-testid={`drag-handle-${optionIndex}`}
          />
        )}
        {isCheckboxEnabled && <Checkbox {...{ name, optionIndex }} />}
        <Typography
          data-testid="address-text-field"
          style="body2"
          className={classNames("flex-grow truncate leading-4", {
            "neeto-ui-text-gray-400": isNotPresent(label),
          })}
        >
          {label || placeholder}
        </Typography>
        <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100">
          <Button
            className="neeto-ui-rounded hover:neeto-ui-bg-gray-400 p-1"
            data-testid="address-field-edit-button"
            icon={Edit}
            size="small"
            style="text"
            tooltipProps={{
              content: t("neetoMolecules.common.actions.edit"),
              position: "top",
              touch: ["hold", 500],
            }}
            onClick={() => onEdit(id)}
          />
          <OptionActions
            {...{
              arrayHelpers,
              hideCloneOption,
              hideDeleteOption,
              id,
              onClone,
              optionIndex,
            }}
            className="flex items-center gap-2"
            onDelete={handleDeleteClick}
          />
        </div>
      </div>
    </div>
  )
);

export default BlockOption;
